"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNewsletterStatus = exports.useNewsletterSubscribe = void 0;
const error_types_1 = require("@epic-mw/error-types");
const react_1 = require("react");
const newsletter_api_1 = require("./newsletter.api");
const useNewsletterSubscribe = () => {
    const [loadingState, setLoadingState] = (0, react_1.useState)({ loading: false, loaded: false, error: "" });
    const [subscribed, setSubscribed] = (0, react_1.useState)(false);
    const subscribe = (0, react_1.useCallback)(async (params) => {
        try {
            setLoadingState({ loading: true, loaded: false });
            const response = (await newsletter_api_1.newsletterApi.subscribeToNewsletter(params)) || {};
            setSubscribed(!!response.ok && !response.error);
            setLoadingState({ loading: false, loaded: true, error: response.errormsg });
        }
        catch (ex) {
            console.error("Failed to subscribe to newsletter", ex);
            const error = ((0, error_types_1.isError)(ex) && ex.message) || "";
            setLoadingState({ loading: false, loaded: true, error });
        }
    }, [setSubscribed, setLoadingState, loadingState]);
    return (0, react_1.useMemo)(() => {
        return Object.assign(Object.assign({ subscribed }, loadingState), { subscribe });
    }, [subscribed, loadingState.loading, loadingState.loaded]);
};
exports.useNewsletterSubscribe = useNewsletterSubscribe;
const useNewsletterStatus = () => {
    const [loadingState, setLoadingState] = (0, react_1.useState)({ loading: false, loaded: false, error: "" });
    const [subscribed, setSubscribed] = (0, react_1.useState)(false);
    const getStatus = (0, react_1.useCallback)(async () => {
        try {
            setLoadingState({ loading: true, loaded: false });
            const response = (await newsletter_api_1.newsletterApi.getSubscriptionStatus()) || {};
            setSubscribed(!!response.listSubscribed && !response.productSubscribed);
            setLoadingState({ loading: false, loaded: true });
        }
        catch (ex) {
            console.error("Failed to subscribe to newsletter", ex);
            const error = ((0, error_types_1.isError)(ex) && ex.message) || "";
            setLoadingState({ loading: false, loaded: true, error });
        }
    }, [setLoadingState, setSubscribed]);
    return (0, react_1.useMemo)(() => {
        return Object.assign({ subscribed,
            getStatus }, loadingState);
    }, [subscribed, loadingState.loading, loadingState.loaded]);
};
exports.useNewsletterStatus = useNewsletterStatus;
//# sourceMappingURL=newsletter.hooks.js.map